import { TOKEN_STORAGE_KEY } from 'consts';
import { selectCallConfig, selectLocalParticipant, selectRoomId } from 'state/selectors';

type ConnectPayload = { jwtToken?: string; wssUrl?: string } | { waitingListId: string };

type GetTokenAndWssUrl = (
    roomId: string,
    userName: string,
    waitingListId?: string,
) => Promise<{ payload?: ConnectPayload; error?: unknown } | undefined>;

const getJwtFromConnectPayload = (payload?: ConnectPayload): string | null => {
    if (!payload || !('jwtToken' in payload)) {
        return null;
    }
    return payload.jwtToken ?? null;
};

/** Conference JWT для VCS API: сначала sessionStorage, без лишнего joinCallByLink. */
export const getConferenceJwtToken = async (getTokenAndWssUrl: GetTokenAndWssUrl): Promise<string | null> => {
    const fromSession = sessionStorage.getItem(TOKEN_STORAGE_KEY);
    if (fromSession) {
        return fromSession;
    }

    const fromCallConfig = selectCallConfig()?.auth?.jwtToken;
    if (fromCallConfig) {
        return fromCallConfig;
    }

    const localParticipant = selectLocalParticipant();
    const tokenResult = await getTokenAndWssUrl(
        selectRoomId(),
        localParticipant?.name ?? localParticipant?.identity ?? '',
    );

    return getJwtFromConnectPayload(tokenResult?.payload);
};
